import { Editor } from "@tinymce/tinymce-react";
import React, { useState } from "react";
import { DraggableProvided } from "react-beautiful-dnd";
import { BarLoader } from "react-spinners";
import {
  useWorkShop,
  WorkshopSectionContent,
} from "../../../../../../../contexts/workshop-context/WorkshopContext";
// @ts-ignore
import renderHTML from "react-render-html";
import MediaCard from "../MediaCard";

interface IProps {
  resource: WorkshopSectionContent;
  uploading?: boolean;
  provided: DraggableProvided;
}

const MediaText = (props: IProps) => {
  const workshop = useWorkShop();
  const [loading, setLoading] = useState(true);
  return (
    <MediaCard
      resource={props.resource}
      uploading={props.uploading}
      provided={props.provided}
    >
      {props.resource.mode === "EDIT" ? (
        <div>
          {loading && (
            <div>
              <label>Loading editor please wait.</label>
              <BarLoader
                height={4}
                width={"100%"}
                color={"#006699"}
                loading={loading}
              />
            </div>
          )}
          <div style={loading ? { display: "none" } : { display: "block" }}>
            <Editor
              id={props.resource?.id}
              value={props.resource?.content}
              onInit={() => setLoading(false)}
              apiKey={"t5wauipzy7x1msgvu2y1n2x4fg9vdd3nzbumusv71li0ys00"}
              init={{
                height: 200,
                menubar: false,
                media_poster: false,
                media_alt_source: false,
                plugins: [
                  "advlist autolink lists link image charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                  "undo redo | styleselect | forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | media",
              }}
              onEditorChange={(a, editor) => {
                workshop.updateResource(workshop.selectedSubSection, {
                  ...props.resource,
                  content: a,
                });
              }}
            />
          </div>
        </div>
      ) : (
        <div className="text-center resource-preview-wrapper">
          <div className="resource-preview text-justify">
            {renderHTML(props.resource.content)}
          </div>
        </div>
      )}
    </MediaCard>
  );
};

export default MediaText;
